/*
 * @Author: ç¯çç§æ(Lucas Huang)
 * @Date: 2019-06-16 13:44:59
 * @LastEditors: ç¯çç§æ(Lucas Huang)
 * @LastEditTime: 2019-10-24 13:49:33
 * @QQ: 1055818239
 * @Version: v0.0.1
 */
import { NgModule, ModuleWithProviders } from '@angular/core';
import { FarrisSafePipe } from './safe.pipe';
import { FarrisTemplateDirective } from './directives/farris-template.directive';
import { IdService } from './id.service';
import { ResizeObserverDirective } from './directives/resize-observer.directive';
import { FarrisReplaceXPipe } from './replaceX.pipe';
import { RuntimeStateService } from './service/runtime-state.service';
import { CommonUtils } from './common.utils';
import { GetValuePipe } from './directives/getvalue.pipe';
import { FarrisComponentTemplateDirective } from './directives/component-template.directive';
import { OverLayHiddenService } from './service/overlay-hidden.service';

@NgModule({
    declarations: [
        FarrisSafePipe,
        FarrisTemplateDirective,
        ResizeObserverDirective,
        FarrisReplaceXPipe,
        GetValuePipe,
        FarrisComponentTemplateDirective
    ],
    imports: [
    ],
    exports: [
        FarrisSafePipe,
        FarrisTemplateDirective,
        ResizeObserverDirective,
        FarrisReplaceXPipe,
        GetValuePipe,
        FarrisComponentTemplateDirective
    ]
})
export class FarrisCommonModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: FarrisCommonModule,
            providers: [
                CommonUtils,
                RuntimeStateService,
                IdService,
                OverLayHiddenService
            ]
        };
    }
}
